function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Tracker setup (COMMERCE_ONBOARDING · Task C) — surfaces the live /v1/tracking
// backend (snippet · scan · events-script) + a live-traffic verification loop
// (tracking-setup-2026-08-24.html). Top-tier styling via onboarding-css.
// New /Tracking route — distinct from /Data/Tracking (the §290 host-allowlist page).

import React from "react";
import { withRouter } from "react-router";
import PubSub from "pubsub-js";
import ServiceFactory from "../../service";
import account from "../../data/account";
import { Loader } from "../../components/loaders";
import { getOnboardingStatus, shopifyThemeEmbedUrl } from "../../functions/onboarding-status";
import { OB_CSS } from "./onboarding-css";

// Shopify stores (2026-11-03, review item 14): the Plunk theme app embed is installed when the store connects, so
// there is no snippet to paste and no page scan; this page shows the embed state, the theme-editor deep link and
// the live-traffic check. Copy stays industry-neutral (DS rule): no furniture placeholders.
const SHOPIFY_EVENTS_PLACEHOLDER = "Newsletter signup, Contact form";
const trk = api => {
  const S = ServiceFactory.getType(`/tracking${api}`, "product");
  return new S();
};
const askPlunk = starter => PubSub.publish("plunk-assistant-toggle", {
  starter
});
const normUrl = u => !u ? "" : /^https?:\/\//i.test(u) ? u : `https://${u}`;
const ago = d => {
  if (!d) return "";
  const s = Math.max(0, (Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return `${Math.round(s)}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};
class TrackingSetupView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "refreshTraffic", async () => {
      const s = await trk("/status").getAsync().catch(() => null);
      if (!this._alive || !s) return;
      this.setState({
        traffic: s.tracker || null,
        live: !!(s.tracker && s.tracker.hasData)
      });
    });
    _defineProperty(this, "copySnippet", () => {
      try {
        navigator.clipboard.writeText(this.state.snippet);
        this.setState({
          copied: true
        });
        setTimeout(() => this._alive && this.setState({
          copied: false
        }), 1800);
      } catch (e) {/* clipboard blocked */}
    });
    _defineProperty(this, "runScan", async () => {
      const url = normUrl(this.state.url.trim());
      if (!url) return;
      this.setState({
        scanning: true,
        scan: null,
        scanError: null
      });
      try {
        const r = await trk("/scan").postAsync({
          url
        });
        if (this._alive) this.setState({
          scanning: false,
          scan: r
        });
      } catch (e) {
        if (this._alive) this.setState({
          scanning: false,
          scanError: "We couldn't run the scan. Check the address (https://…) and try again."
        });
      }
    });
    _defineProperty(this, "genScript", async () => {
      const events = this.state.eventText.split(",").map(s => s.trim()).filter(Boolean).map(name => ({
        name,
        kind: "conversion"
      }));
      if (!events.length) {
        this.setState({
          scriptError: "Add at least one action name."
        });
        return;
      }
      this.setState({
        generating: true,
        script: null,
        scriptError: null
      });
      try {
        const r = await trk("/events-script").postAsync({
          events,
          ga4: true
        });
        if (this._alive) this.setState({
          generating: false,
          script: r && (r.script || r.content) || (typeof r === "string" ? r : JSON.stringify(r, null, 2))
        });
      } catch (e) {
        if (this._alive) this.setState({
          generating: false,
          scriptError: "Couldn't generate the script. Pick at least one action name."
        });
      }
    });
    const domain = (account.get() || {}).domain || "";
    this.state = {
      loading: true,
      snippet: "",
      placement: "",
      copied: false,
      url: normUrl(domain),
      scanning: false,
      scan: null,
      scanError: null,
      eventText: "Quote Request, Dealer Locator",
      generating: false,
      script: null,
      scriptError: null,
      live: false,
      traffic: null,
      shopify: false,
      shop: ""
    };
    this._alive = true;
    this._poll = null;
  }
  async componentDidMount() {
    const [snip, ob] = await Promise.all([trk("/snippet").getAsync().catch(() => null), getOnboardingStatus().catch(() => null)]);
    if (!this._alive) return;
    const shopify = !!(ob && ob.shopify);
    this.setState({
      loading: false,
      snippet: snip && snip.snippet || "",
      placement: snip && snip.placement || "",
      live: !!(ob && ob.steps && ob.steps.tracker),
      traffic: ob && ob.raw && ob.raw.tracker || null,
      shopify,
      shop: ob && ob.shop || "",
      eventText: shopify ? SHOPIFY_EVENTS_PLACEHOLDER : this.state.eventText
    });
    this._poll = setInterval(this.refreshTraffic, 10000);
  }
  componentWillUnmount() {
    this._alive = false;
    if (this._poll) clearInterval(this._poll);
  }
  render() {
    const {
      loading,
      snippet,
      placement,
      copied,
      url,
      scanning,
      scan,
      scanError,
      eventText,
      generating,
      script,
      scriptError,
      live,
      traffic,
      shopify,
      shop
    } = this.state;
    if (loading) return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement(Loader, null));
    const verified = scan && scan.reachable && scan.tenantCorrect > 0;
    const liveTraffic = /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-rowhead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Live traffic"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      onClick: this.refreshTraffic
    }, "Check now")), traffic && traffic.hasData ? /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontSize: "12.5px",
        color: "var(--ob-ok)",
        fontWeight: 700
      }
    }, "\u2713 Live: ", Number(traffic.impressions || 0).toLocaleString(), " events recorded", traffic.lastEventDate ? `, last ${ago(traffic.lastEventDate)}` : "", ".") : /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        margin: 0
      }
    }, shopify ? "No traffic yet. Open any page of your storefront once and it appears here within seconds. This rechecks automatically." : "No traffic yet. Once the snippet is live, load any page on your site (or fire a test action) and it'll appear here within seconds. This rechecks automatically."));
    const keyActions = /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Track your key actions"), /*#__PURE__*/React.createElement("p", {
      className: "ob-hint"
    }, shopify ? /*#__PURE__*/React.createElement(React.Fragment, null, "Carts, checkouts and orders already count. Name any other action that matters to you and we generate a ", /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "ui-monospace,monospace"
      }
    }, "plunk-events.js"), " to add to your theme, one call per action.") : /*#__PURE__*/React.createElement(React.Fragment, null, "Name the actions that matter and we generate a ", /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "ui-monospace,monospace"
      }
    }, "plunk-events.js"), " your developer drops in, one call per action.")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap",
        marginTop: 8
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "ob-input",
      style: {
        flex: "1 1 320px"
      },
      value: eventText,
      onChange: e => this.setState({
        eventText: e.target.value
      }),
      placeholder: shopify ? SHOPIFY_EVENTS_PLACEHOLDER : "Quote Request, Dealer Locator"
    }), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      disabled: generating,
      onClick: this.genScript
    }, generating ? "Generating…" : "Generate script")), scriptError && /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        color: "var(--ob-warn)"
      }
    }, scriptError), script && /*#__PURE__*/React.createElement("pre", {
      className: "ob-code",
      style: {
        marginTop: 8,
        maxHeight: 260
      }
    }, script));
    if (shopify) {
      const editor = shopifyThemeEmbedUrl(shop);
      return /*#__PURE__*/React.createElement("div", {
        className: "ob-root"
      }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
        className: "ob-wrap",
        style: {
          maxWidth: "820px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "ob-eyebrow"
      }, "Setup \xB7 step 2 \xB7 tracking \xB7 Shopify"), /*#__PURE__*/React.createElement("div", {
        className: "ob-hrow"
      }, /*#__PURE__*/React.createElement("h2", null, "Tracking is on via the Plunk app embed in your theme")), /*#__PURE__*/React.createElement("p", {
        className: "ob-next",
        style: {
          color: "var(--ob-muted)"
        }
      }, "Plunk added its app embed to your theme when you connected ", shop || "your store", ". It records storefront visits, product views, scroll, clicks and forms; checkout is covered by the Plunk app pixel. Nothing to paste."), /*#__PURE__*/React.createElement("div", {
        className: "ob-steps",
        style: {
          marginTop: 14
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "s done"
      }, /*#__PURE__*/React.createElement("b", null, "App embed installed \u2713"), "added at connect"), /*#__PURE__*/React.createElement("div", {
        className: `s ${live ? "done" : "now"}`
      }, /*#__PURE__*/React.createElement("b", null, "Embed on in your theme", live ? " ✓" : ""), live ? "reporting" : "check it is switched on"), /*#__PURE__*/React.createElement("div", {
        className: `s ${live ? "done" : ""}`
      }, /*#__PURE__*/React.createElement("b", null, "Go live", live ? " ✓" : ""), live ? "traffic arriving" : "open your storefront once")), /*#__PURE__*/React.createElement("div", {
        className: "ob-sec"
      }, /*#__PURE__*/React.createElement("span", {
        className: "lab"
      }, "Your theme"), /*#__PURE__*/React.createElement("p", {
        className: "ob-hint",
        style: {
          margin: "4px 0 10px"
        }
      }, "The embed is enabled on install. If your theme shows it switched off, or you have changed themes, open the theme editor: the Plunk embed is pre-selected, click ", /*#__PURE__*/React.createElement("b", null, "Save"), ", then open your storefront once."), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          alignItems: "center"
        }
      }, editor ? /*#__PURE__*/React.createElement("a", {
        className: "ob-btn",
        href: editor,
        target: "_blank",
        rel: "noreferrer"
      }, "Open theme editor") : /*#__PURE__*/React.createElement("span", {
        className: "ob-hint",
        style: {
          margin: 0
        }
      }, "Open your Shopify admin, then Online Store \u203A Themes \u203A Customize \u203A App embeds, and make sure Plunk is on."))), liveTraffic, keyActions, /*#__PURE__*/React.createElement("div", {
        className: "ob-sec"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ob-dash"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          flex: "1 1 360px"
        }
      }, /*#__PURE__*/React.createElement("b", null, "Not seeing traffic?"), " Ask Plunk can check the embed with you, or draft a note to whoever manages your theme."), /*#__PURE__*/React.createElement("button", {
        className: "ob-btn ai sm",
        onClick: () => askPlunk("My Shopify storefront is not reporting traffic to Plunk. How do I check the Plunk app embed in my theme?")
      }, "\uD83D\uDCAC Ask Plunk")), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "ob-btn ghost sm",
        onClick: () => this.props.history.push("/Setup")
      }, "\u2190 Back to setup")))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root"
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      className: "ob-wrap",
      style: {
        maxWidth: "820px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-eyebrow"
    }, "Setup \xB7 step 2 \xB7 tracking"), /*#__PURE__*/React.createElement("div", {
      className: "ob-hrow"
    }, /*#__PURE__*/React.createElement("h2", null, "Install & verify your tracker")), /*#__PURE__*/React.createElement("p", {
      className: "ob-next",
      style: {
        color: "var(--ob-muted)"
      }
    }, "One script on every page turns on live traffic, contacts and funnels, from today forward."), /*#__PURE__*/React.createElement("div", {
      className: "ob-steps",
      style: {
        marginTop: 14
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "s done"
    }, /*#__PURE__*/React.createElement("b", null, "Get your snippet \u2713"), "prefilled for this workspace"), /*#__PURE__*/React.createElement("div", {
      className: `s ${verified ? "done" : "now"}`
    }, /*#__PURE__*/React.createElement("b", null, "Verify install", verified ? " ✓" : ""), "scan your pages"), /*#__PURE__*/React.createElement("div", {
      className: `s ${live ? "done" : ""}`
    }, /*#__PURE__*/React.createElement("b", null, "Go live", live ? " ✓" : ""), live ? "traffic arriving" : "traffic flips this on")), /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-rowhead"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Your snippet, ready to paste"), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      onClick: this.copySnippet
    }, copied ? "Copied ✓" : "Copy")), /*#__PURE__*/React.createElement("pre", {
      className: "ob-code"
    }, snippet), placement && /*#__PURE__*/React.createElement("p", {
      className: "ob-hint"
    }, placement)), /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("span", {
      className: "lab"
    }, "Verify installation"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap",
        margin: "9px 0"
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: "ob-input",
      style: {
        flex: "1 1 320px"
      },
      value: url,
      onChange: e => this.setState({
        url: e.target.value
      }),
      placeholder: "https://www.example.com"
    }), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn",
      disabled: scanning,
      onClick: this.runScan
    }, scanning ? "Scanning…" : "Scan my pages")), scanError && /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        color: "var(--ob-warn)"
      }
    }, scanError), scan && scan.reachable === false && /*#__PURE__*/React.createElement("p", {
      className: "ob-hint",
      style: {
        color: "var(--ob-warn)"
      }
    }, scan.message || "We couldn't reach that site. Check the address and try again."), scan && scan.reachable !== false && /*#__PURE__*/React.createElement("div", {
      className: "ob-scan",
      style: {
        marginTop: 6
      }
    }, (scan.pages || []).slice(0, 12).map((p, i) => /*#__PURE__*/React.createElement("div", {
      className: "r",
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: p.tenantCorrect ? "var(--ob-ok)" : p.trackerPresent ? "var(--ob-warn)" : "#c2402f",
        fontWeight: 800
      }
    }, p.tenantCorrect ? "✓" : p.trackerPresent ? "!" : "×"), /*#__PURE__*/React.createElement("span", {
      style: {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, p.url), /*#__PURE__*/React.createElement("span", {
      className: "ob-hint",
      style: {
        margin: 0
      }
    }, p.tenantCorrect ? "correct workspace" : p.trackerPresent ? "wrong workspace id" : "no tracker"))), scan.verdict && /*#__PURE__*/React.createElement("p", {
      style: {
        fontWeight: 700,
        fontSize: "12.5px",
        margin: "9px 0 0",
        color: verified ? "var(--ob-ok)" : "var(--ob-warn)"
      }
    }, scan.verdict))), liveTraffic, keyActions, /*#__PURE__*/React.createElement("div", {
      className: "ob-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ob-dash"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        flex: "1 1 360px"
      }
    }, /*#__PURE__*/React.createElement("b", null, "Stuck installing it?"), " Ask Plunk can write a copy-paste guide for your platform, or draft a note to your developer."), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ai sm",
      onClick: () => askPlunk("How do I add the Plunk tracker to my site?")
    }, "\uD83D\uDCAC Ask Plunk")), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "ob-btn ghost sm",
      onClick: () => this.props.history.push("/Setup")
    }, "\u2190 Back to setup")))));
  }
}
export default withRouter(TrackingSetupView);
export const TrackingSetupViewComponent = withRouter(TrackingSetupView);